import { render, staticRenderFns } from "./TabelaAplicacoes.vue?vue&type=template&id=975e4b46"
import script from "./TabelaAplicacoes.vue?vue&type=script&lang=js"
export * from "./TabelaAplicacoes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports